var borders_default = {
  "borderT": "LGrOH",
  "borderB": "LBcvZ",
  "borderL": "uO4YP",
  "borderR": "Hf-39"
};
export {
  borders_default as default
};
//# sourceMappingURL=borders-scss.js.map
